import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LControlLayers = _resolveComponent("LControlLayers")!
  const _component_MapyCzBasicLayer = _resolveComponent("MapyCzBasicLayer")!
  const _component_MapyCzOrthoPhotoLayer = _resolveComponent("MapyCzOrthoPhotoLayer")!
  const _component_LControlZoom = _resolveComponent("LControlZoom")!
  const _component_LMap = _resolveComponent("LMap")!

  return (_openBlock(), _createBlock(_component_LMap, {
    center: _ctx.centerLatLng,
    zoom: _ctx.zoom,
    options: {zoomSnap: 0.25, preferCanvas: true, zoomControl: false, maxZoom: 21},
    class: "h-100",
    onReady: _ctx.onMapReady
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LControlLayers, {
        position: "topleft",
        onReady: _ctx.onLayersControlReady
      }, null, 8, ["onReady"]),
      _createVNode(_component_MapyCzBasicLayer),
      _createVNode(_component_MapyCzOrthoPhotoLayer, { visible: false }),
      _createVNode(_component_LControlZoom, { position: "topleft" })
    ]),
    _: 1
  }, 8, ["center", "zoom", "onReady"]))
}